module.exports = __webpack_public_path__ + "static/fondofooter2-681a753568886d54c2c7b57d61adef02.jpg";